import { Tab } from "@blueprintjs/core";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { BackButton, PageBase, ProtectedTabs } from "../../../components";
import { ERoutes } from "../../../ERoutes";
import { useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { PersonFusionPage } from "./PersonFusionPage";

export interface IPersonFusionItemPageProps {}

export const PersonFusionItemPage: React.FunctionComponent<IPersonFusionItemPageProps> = (props) => {
  const { id, tab } = useParams<{ id: string; tab: string }>();
  const { t } = useTl();
  const history = useHistory();

  return (
    <PageBase
      breadCrumbs={[
        {
          text: t(ETLCodes.PeopleFusion),
          route: ERoutes.people,
        },
      ]}
    >
      <ProtectedTabs
        id="FusePersonTabs"
        onChange={(newTabId) => history.push(`${ERoutes.people}/${id}/${newTabId}/edit`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.people}/>
        <Tab id="fusion" title={t(ETLCodes.Fusion)} panel={<PersonFusionPage />} />
      </ProtectedTabs>
    </PageBase>
  );
};
